import {whatsAppParser} from "@src/helpers/messageHelper";
import ChatMessage from "@src/types/ChatMessage";
import {shorten} from "@src/helpers/utils";

export const getLastMessageText = (message: ChatMessage): string => {
  if (!message) return 'Mensagem desconhecida';

  if (message.status === '5') return 'Mensagem apagada';

  switch (message.type) {
    case 'text':
      return whatsAppParser(shorten(message.message));
    case 'image':
      return 'Imagem';
    case 'audio':
      return 'Áudio';
    case 'video':
      return 'Vídeo';
    case 'location':
      return 'Localização';
    case 'contact':
      return 'Contato';
    case 'sticker':
      return 'Figurinha';
    case 'vcard':
      return 'Cartão de Visita';
    case 'document':
      return 'Documento';
    case 'link':
      try {
        const rawJson = message.message || '{"message": "Texto com Link", "url": ""}';
        const data = JSON.parse(rawJson);

        return `${data.message} - ${data.url}`;
      } catch (error) {
        console.error('Erro ao processar link:', error);
        return 'Link inválido';
      }
    default:
      return whatsAppParser(shorten(message.message));
  }
};

export const getLastMessageDate = (dataString:string): string => {
  const data = new Date(dataString);
  const today = new Date();

  const isToday = data.getDate() === today.getDate() &&
    data.getMonth() === today.getMonth() &&
    data.getFullYear() === today.getFullYear();

  if (isToday) {
    return data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  } else {
    return data.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    });
  }
};

